import { render, staticRenderFns } from "./EventCommentReplyWriteComponent.vue?vue&type=template&id=11810d1c&scoped=true"
import script from "./EventCommentReplyWriteComponent.vue?vue&type=script&lang=js"
export * from "./EventCommentReplyWriteComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11810d1c",
  null
  
)

export default component.exports